import React from "react";
import { isMobile } from "react-device-detect";
import { ReactSortable } from "react-sortablejs";
import { useTranslation } from "react-i18next";
import {Empty} from "antd";
import { SVG_DRAGDROP } from "svg/SVGs";
import { AED } from "features/order-taking/pages/take-order/components/icons";


const ModifierView = ({ mod, actionButtons }) => {
  const { t } = useTranslation();
  
  return (
    <div className="grid grid-cols-12 items-center border-b p-2 md:p-4 text-16px hover:bg-gray-100 cursor-pointer gap-2">
  
    {/* Drag icon */}
    <div className="col-span-1 flex items-center">
      <div className="w-5 h-5 cursor-move">
        <SVG_DRAGDROP />
      </div>
    </div>
  
    {/* Name (MAIN — takes more space) */}
    <h3 className="col-span-6 text-14px truncate">
      {mod?.baseLanguage?.name}
    </h3>
  
    {/* Max Order Qty */}
    <h3 className="col-span-3 text-14px">
      <span className="font-semibold">{t("Max Order Quantity")}:</span>{" "}
      {mod?.maximumOrderQuantity}
    </h3>
  
    {/* Price */}
    <div className="col-span-1 text-14px flex gap-1 items-center flex-wrap">
      <AED width={16} height={16} />
      {mod?.price}
    </div>
  
    {/* Actions */}
    <div className="col-span-1 flex justify-end">
      {actionButtons(mod)}
    </div>
  
  </div>
  );
};

const ModifierDragger = ({
  modifiers,
  reOrderCategory,
  actionButtons=()=>{},
  mode="edit",
}) => {
  const { t } = useTranslation();

  return (
    <>
      {modifiers && modifiers?.length >= 1 ? (
        (isMobile || mode !== "edit" )? (
          <>
            {modifiers &&
              modifiers?.map((cat, index) => {
                return (
                  <ModifierView
                    mod={cat}
                    key={cat._id}
                    actionButtons={actionButtons}
                  />
                );
              })}
          </>
        ) : (
          <ReactSortable
            list={modifiers}
            setList={() => {}}
            animation={300}
            onUpdate={(order) => {
                // console.log(order);
              reOrderCategory(order);
            }}
          >
            {modifiers &&
              modifiers?.map((cat, index) => {
                return (
                  <ModifierView
                    mod={cat}
                    key={cat._id}
                    actionButtons={actionButtons}
                  />
                );
              })}
          </ReactSortable>
        )
      ) : (
        <div className="flex justify-center w-full">
          <Empty
            description={<span>{t("There is no modifier attached")}</span>}
          />
        </div>
      )}
    </>
  );
}

export default ModifierDragger;
